import React from "react";
import HeaderGuest from "../../components/Header/HeaderGuest";

export default function ExplainerVideo() {
    return (
        <section>
        <header className="py-3 mb-2 shadow-lg">
            <HeaderGuest />
        </header>
        <div className="min-h-screen bg-gray-50 flex items-center justify-center py-8 pt-0 px-4">
            <div className="w-full max-w-4xl bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
                <h1 className="text-3xl font-bold text-gray-800 text-center mb-6">
                    Watch Our Explainer Video
                </h1>

                <p className="text-center text-gray-600 mb-8 text-lg">
                    Learn how the 360° Feedback system works and how to get the best out of it.
                </p>

                {/* VIDEO CONTAINER — replace src later */}
                <div className="relative w-full h-64 sm:h-96 bg-gray-200 rounded-xl overflow-hidden shadow-md">
                    <iframe
                            src="/2025_360 feedback.mp4"  
                        title="Explainer Video"
                        className="w-full h-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>

                <div className="mt-8 text-center text-gray-600">
                    <p>If the video does not load, please check your network connection and reload the page.</p>
                </div>
            </div>
        </div>
        </section>
    );
}